//
//
//
//
//
//
//
//
//
//
//
//
import { getAction } from '@/api/manage';
import DashChartDemo from '@/components/chart/DashChartDemo';
import ARow from 'ant-design-vue/es/grid/Row';
export default {
  name: 'DiskMonitoring',
  components: {
    ARow: ARow,
    DashChartDemo: DashChartDemo
  },
  data: function data() {
    return {
      description: '磁盘监控',
      //数据集
      diskInfo: [],
      url: {
        queryDiskInfo: 'actuator/redis/queryDiskInfo'
      }
    };
  },
  created: function created() {
    var _this = this;

    getAction(this.url.queryDiskInfo).then(function (res) {
      if (res.success) {
        for (var i = 0; i < res.result.length; i++) {
          res.result[i].restPPT = res.result[i].restPPT / 10;
        }

        _this.diskInfo = res.result;
      }
    });
  }
};